export const theme = {
  section: {
    width: '100vw',
    marginLeft: 'calc(50% - 50vw)',
    backgroundColor: '#f6f7fb',
  },
  container: {
    maxWidth: '1100px',
    padding: '20px',
    margin: '0 auto',
    backgroundColor: '#fff',
  },
  title: {
    fontSize: '1.5rem',
    fontWeight: '600',
    textAlign: 'center',
    marginBottom: '10px',
  },
  pointsBox: { display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '10px' },
  mapContainer: {
    height: '450px',
    border: 'transparent',
  },
};
